// Copyright (c) Docugami, Inc. All rights reserved.**/import DOMPurify from "dompurify";

import DOMPurify from "dompurify";
import { useMemo } from "react";

interface SanitizingHtmlViewerProps {
    html: string | undefined;
    className?: string;
}

const allowedTags = ['TABLE', 'TBODY', 'TR', 'TD', 'OL', 'UL', 'LI', 'LIM', 'DIV', 'H1', 'P', 'OUTFLOW_CONTAINER', 'IMG', 'FIGURE', 'FIGCAPTION', 'SPAN', 'HEADER', 'FOOTER'];

export const SanitizingHtmlViewer = (props: SanitizingHtmlViewerProps) => {
    const sanitizedHtml = useMemo(() => {
        const invalidTags = new Set();
        DOMPurify.addHook("uponSanitizeElement", node => {
            // "BODY" is the root elemenet created by the sanitizer
            if (!!node.tagName && node.tagName !== 'BODY' && !allowedTags.includes(node.tagName)) {
                invalidTags.add(node.tagName)
            }
        })

        let input = props.html ?? '';
        let purified = DOMPurify.sanitize(input)
        if (invalidTags.size > 0) {
            // There was some document text interpreted as HTML - we need to escape those tags and re-encode
            // Invalidating the start tag by encoding "<" as "&lt;" will make the tag no longer HTML so it
            // will be treated as text.
            // https://www.w3.org/TR/REC-xml/#sec-starttags
            for (const tag of Array.from(invalidTags.values())) {
                const regex = new RegExp(`</?${tag}\\b`, "gi");
                input = input.replaceAll(regex, match => `&lt;${match.substring(1)}`)
            }

            DOMPurify.removeAllHooks();
            purified = DOMPurify.sanitize(input);
        }

        DOMPurify.removeAllHooks();
        return purified
    }, [props.html]);

    if (!props.html)
        return null;

    return <div className={props.className} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};
